import React from 'react'
import AreaContent from '../components/AreaContent';
import AreaInfo from '../components/AreaInfo';
import AreaLogs from '../components/AreaLogs';
import Button from '../DMGComponents/Button';
import { getAreaForApproval, approveArea, denyArea } from '../fetchData';
import { withMsal } from "@azure/msal-react";
import Spinner from '../components/Spinner';
import UserManagement from '../components/UserManagement';
import { isViableDMGUser } from '../authProvider';
import toast, { Toaster } from 'react-hot-toast';
import { getParameterByName } from '../utils/helperFunctions';
import FileExLogo from '../components/FileExLogo';
import AuthenticatedHeader from '../components/AuthenticatedHeader';
import { AreaProvider } from '../components/AreaContext';
import { confirmAlert } from 'react-confirm-alert';
import '../assets/css/react-confirm-alert.css';

class ApproveArea extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            area: null,
            loaded: false,
            moreShown: false,
        }
    }

    componentDidMount() {
        let areaId = null;
        let urlAreaIdParam = getParameterByName("areaId");
        if (urlAreaIdParam) {
            areaId = parseInt(urlAreaIdParam);
            getAreaForApproval(areaId).then((res) => {
                if (res.isError) {
                    toast.error(res.data)
                    this.setState({
                        loaded: true
                    });
                }
                else {
                    this.setState({
                        area: res,
                        loaded: true
                    });
                }
            }).catch((err) => {
                toast.error("There was an error loading the area.")
                this.setState({
                    loaded: true
                });
            });
        }
    }

    toggleShowMore = () => {
        let newState = !this.state.moreShown;
        this.setState({
            moreShown: newState,
        })
    }

    approveArea = () => {
        approveArea(this.state.area.id).then(() => {
            this.setState(prevState => {
                let newArea = { ...prevState.area };
                newArea.status = 1;
                console.log(newArea);
                return { area: newArea };
            })
            toast.success("Area approved.");
        }).catch((err) => {
            console.error("Error", err)
        });
    }

    openDenyModal = () => {
        const areaName = this.state.area.name;
        confirmAlert({
            customUI: ({ onClose }) => {
                let reason = '';
                return (
                    <div style={{
                        background: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '24px',
                        maxWidth: '480px',
                        boxShadow: '0 2px 12px rgba(0,0,0,0.15)'
                    }}>
                        <h3 style={{ marginTop: 0 }}>Deny Area</h3>
                        <p style={{ marginBottom: '8px' }}>
                            Denying this area will permanently delete it.
                        </p>
                        <p style={{ marginBottom: '12px', color: '#555' }}>
                            Area: <strong>{areaName}</strong>
                        </p>
                        <textarea
                            placeholder="Reason (optional)"
                            onChange={(e) => { reason = e.target.value; }}
                            onMouseUp={(e) => e.stopPropagation()}
                            style={{
                                width: '100%',
                                minHeight: '80px',
                                boxSizing: 'border-box',
                                marginBottom: '16px',
                                padding: '8px',
                                fontFamily: 'inherit',
                                fontSize: '14px',
                                resize: 'vertical'
                            }}
                        />
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                            <Button type="hover-bottom-left" onClick={onClose}>Cancel</Button>
                            <Button type="hover-bottom-left" onClick={() => {
                                onClose();
                                denyArea(this.state.area.id, reason).then(() => {
                                    this.setState({ area: null });
                                    toast.success('Area denied and deleted.');
                                }).catch((err) => {
                                    console.error('Error denying area', err);
                                    toast.error('Error denying area.');
                                });
                            }}>Deny</Button>
                        </div>
                    </div>
                );
            }
        });
    }

    render() {
        return (
            <div>
                <Toaster />
                <div>
                    <AuthenticatedHeader isUsaVersion={this.props.appSettings.isUsaVersion} />
                    {!isViableDMGUser()
                        ?
                        (<div style={{ flex: '1' }}>
                            <FileExLogo />
                            <p>Please login with a <i>my</i> DMG MORI account.</p>
                        </div>)
                        :
                        !this.props.accessChecked
                            ?
                            (<div style={{ flex: '1' }}>
                                <FileExLogo />
                                <p>Checking permissions...</p>
                            </div>)
                            :
                            this.props.userAllowed
                                ?
                                <React.Fragment>
                                    <FileExLogo />
                                    {this.state.area != null && this.state.area.status === 1 &&
                                        <div style={{ color: "red", fontWeight: "bold"}}>
                                            Area is approved.
                                        </div>
                                    }
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {!this.state.loaded ?
                                            <div style={{ flex: '1' }}>
                                                <Spinner />
                                            </div>
                                            :
                                            <div style={{ display: 'flex', flex: '1', alignItems: 'center', justifyContent: 'center' }}>
                                                {this.state.area != null &&
                                                    <div style={{ flex: '1', justifyContent: "left", paddingRight: "6px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <div style={{ display: "flex", textAlign: "left", alignItems: "center" }}>
                                                                Area name:{'\u00A0'}{this.state.area.name}
                                                            </div>
                                                            <div style={{ display: "flex", textAlign: "left" }}>
                                                                Description:{'\u00A0'}{this.state.area.description}
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.area != null &&
                                                    <div style={{ display: "flex", justifyContent: "right", gap: "8px" }}>
                                                        <Button type="hover-bottom-left" disabled={this.state.area?.status === 1} onClick={() => { this.approveArea() }}>Approve</Button>
                                                        <Button type="hover-bottom-left" disabled={this.state.area?.status === 1} onClick={() => { this.openDenyModal() }}>Deny</Button>
                                                    </div>
                                                }
                                                {this.state.area === null &&
                                                    <div style={{ flex: '0 0 auto' }}>
                                                        Invalid link or no access for approval.
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                    {this.state.area != null &&
                                        <div>
                                            <div>
                                                <AreaProvider>
                                                    <AreaContent area={this.state.area} refreshAreaContent={refreshMethod => this.refreshAreaContent = refreshMethod} updateAreaUsedSpace={() => { }}
                                                        isApprovalMode={true}/>
                                                    {/*{this.state.selectedArea.isOwner && this.state.selectedArea.isAdHoc &&*/}
                                                    {/*    <AdHocUserManagement areaId={this.state.selectedArea?.id} areaStatus={this.state.selectedArea?.status} />*/}
                                                    {/*}*/}
                                                    {/*!this.state.selectedArea.isAdHoc &&*/
                                                        <UserManagement areaId={this.state.area?.id} areaStatus={this.state.area?.status}
                                                            managerApprovalRequired={this.state.area?.managerApprovalRequired} isApprovalMode={true}
                                                        />
                                                    }
                                                    {this.state.moreShown &&
                                                        <div>
                                                            <AreaInfo area={this.state.area} updateAreaExpiration={() => { }} removeArea={() => { }} updateAreaSettings={() => { }}
                                                                isAdHoc={false} />
                                                            <AreaLogs area={this.state.area} isApprovalMode={true} />
                                                            <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px" }}>
                                                                <Button type="hover-bottom-left" onClick={() => this.toggleShowMore()}>Show less</Button>
                                                            </div>
                                                        </div>
                                                    }
                                                    {!this.state.moreShown &&
                                                        <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px" }}>
                                                            <Button type="hover-bottom-left" onClick={() => this.toggleShowMore()}>Show more</Button>
                                                        </div>
                                                    }
                                                </AreaProvider>
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                                :
                                <div style={{ flex: '1' }}>
                                    <FileExLogo />
                                    <p>Forbidden.</p>
                                </div>
                    }
                </div>
            </div>
        );
    }
}
export default withMsal(ApproveArea);